import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import Modal from '../../../common/modal/Modal';
import { postImportHolidays } from '../../../../actions';

const ImportHolidaysModal = ({
  show,
  onClose,
  onImported,
  dispatchPostImportHolidays,
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const onFileChange = (event) => {
    setFile(event.target.files[0] || null);
  };

  const closeModal = () => {
    setFile(null);
    onClose();
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      toastr.error('Error', 'Seleccione un archivo');
      return;
    }

    setUploading(true);
    const result = await dispatchPostImportHolidays(file);
    setUploading(false);

    if (result) {
      setFile(null);
      onClose();
      onImported();
    }
  };

  const body = (
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="holiday-import-file">Archivo</Label>
        <Input
          id="holiday-import-file"
          type="file"
          accept=".xlsx,.xls"
          onChange={onFileChange}
          disabled={uploading}
        />
        <small className="form-text text-muted">
          Columnas esperadas: Fecha (yyyy-MM-dd), Nombre y Descripción
          (opcional). La primera fila se considera cabecera.
        </small>
      </FormGroup>
      <Button type="submit" color="primary" disabled={uploading || !file}>
        <i className="fa fa-upload mr-2" />
        {uploading ? 'Importando...' : 'Importar'}
      </Button>
    </Form>
  );

  return (
    <Modal
      id="import-holidays-modal"
      title="Importar Feriados"
      body={body}
      show={show}
      onClickCancel={closeModal}
      onClickClose={closeModal}
    />
  );
};

ImportHolidaysModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onImported: PropTypes.func.isRequired,
  dispatchPostImportHolidays: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostImportHolidays: postImportHolidays,
};

export default connect(null, mapDispatchToProps)(ImportHolidaysModal);